module.exports = __webpack_public_path__ + "static/img/gallery_5.30d5ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/gallery_5.png
// module id = D+gP
// module chunks = 1